"use strict";
// Copyright 2019 Centrality Investments Limited
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var GenericAsset_1 = require("./GenericAsset");
exports.GenericAsset = GenericAsset_1.GenericAsset;
var GenericAssetRx_1 = require("./GenericAssetRx");
exports.GenericAssetRx = GenericAssetRx_1.GenericAssetRx;
var types_1 = require("./types");
exports.AssetType = types_1.AssetType;
var plugin_1 = require("./plugin");
exports.Plugin = plugin_1.default;
const assetRegistryFns = __importStar(require("./registry/assetRegistry"));
exports.assetRegistry = assetRegistryFns;
//# sourceMappingURL=index.js.map